import { render, staticRenderFns } from "./ModalAssignDoctorToAppt.vue?vue&type=template&id=1bba31c4&scoped=true"
import script from "./ModalAssignDoctorToAppt.vue?vue&type=script&lang=js"
export * from "./ModalAssignDoctorToAppt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bba31c4",
  null
  
)

export default component.exports